import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .hefesto-progress__label {
    display: none;
  }
  .hefesto-modal__body {
    margin-bottom: 8px;
  }
`;

export const ModalOutContainer = styled.div`
  .hefesto-modal__header {
    margin-bottom: 0;
  }
  .hefesto-modal__container {
    padding-top: 20px;
  }
  .hefesto-modal__body {
    margin-bottom: 8px;
  }
  .hefesto-title h3 {
    margin-bottom: 19px;
    line-height: 32px;
  }
  .hefesto-modal__footer {
    display: none;
  }
`;

export const Subtitle = styled.span`
  font-size: 1rem;
  font-weight: 400;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;
